import {lazy} from "react";

const Pdf = lazy(() => import("./Pdf"));

export default Pdf;
